module.exports = __webpack_public_path__ + "static/media/icon-hybrid.044b648a.svg";